module.exports = __webpack_public_path__ + "static/cinemax-1920f4588ff927c00086daf5d78bbde3.png";